import React from 'react'

import 'react-vis/dist/style.css'

import {
  FlexibleWidthXYPlot,
  XAxis,
  YAxis,
  VerticalGridLines,
  HorizontalGridLines,
  VerticalBarSeries,
  DiscreteColorLegend,
  Crosshair
} from 'react-vis'

const DATA = [
  [
    // Bitrate: 5120 kbps
    { x: 'h.265', y: 0.65525464 },
    { x: 'h.264', y: 0.899752 },
  ],
  [
    // Bitrate: 3850 kbps
    { x: 'h.265', y: 0.444107653846 },
    { x: 'h.264', y: 0.495552181818 },
  ],
  [
    // Bitrate: 2560 kbps
    { x: 'h.265', y: 0.315361514286 },
    { x: 'h.264', y: 0.341793217391 },
  ],
  [
    // Bitrate: 2240 kbps
    { x: 'h.265', y: 0.277788821429 },
    { x: 'h.264', y: 0.298737558824 },
  ],
  [
    // Bitrate: 1920 kbps
    { x: 'h.265', y: 0.237930964286 },
    { x: 'h.264', y: 0.25365256 },
  ],
  [
    // Bitrate: 1600 kbps
    { x: 'h.265', y: 0.195937148148 },
    { x: 'h.264', y: 0.213257 },
  ],
  [
    // Bitrate: 1280 kbps
    { x: 'h.265', y: 0.174831346154 },
    { x: 'h.264', y: 0.174870535714 },
  ],
  [
    // Bitrate: 640 kbps
    { x: 'h.265', y: 0.092183 },
    { x: 'h.264', y: 0.0865558928571 },
  ],
  [
    // Bitrate: 320 kbps
    { x: 'h.265', y: 0.0508389615385 },
    { x: 'h.264', y: 0.0471395757576 },
  ]
];

export default class Example extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crosshairValues: []
    };
  }
  render() {
    return (
        <React.Fragment>

          <div className="chart">
            <FlexibleWidthXYPlot
              onMouseLeave={() => this.setState({ crosshairValues: [] })}
              height={300}
              xType="ordinal"
              animation={true}
              stackBy="y">
              
              <VerticalGridLines />
              <HorizontalGridLines />
              <XAxis />
              <YAxis tickFormat={v => `${v}`} />

              <Crosshair values={this.state.crosshairValues} />

              <VerticalBarSeries
                onNearestX={(value, { index }) =>
                  this.setState({ crosshairValues: DATA.map(d => d[index]) })}
                cluster="Bitrate: 5120 kbps"
                color="#FF0000"
                data={DATA[0]}
              />

              <VerticalBarSeries
                cluster="Bitrate: 3850 kbps"
                color="#FF6600"
                data={DATA[1]}
              />

              <VerticalBarSeries
                cluster="Bitrate: 2560 kbps"
                color="#FF6600"
                data={DATA[2]}
              />

              <VerticalBarSeries
                cluster="Bitrate: 2240 kbps"
                color="#FF9900"
                data={DATA[3]}
              />

              <VerticalBarSeries
                cluster="Bitrate: 1920 kbps"
                color="#FFFF00"
                data={DATA[4]}
              />

              <VerticalBarSeries
                cluster="Bitrate: 1600 kbps"
                color="#66FF00"
                data={DATA[5]}
              />

              <VerticalBarSeries
                cluster="Bitrate: 1280 kbps"
                color="#00FFCC"
                data={DATA[6]}
              />

              <VerticalBarSeries
                cluster="Bitrate: 640 kbps"
                color="#0099FF"
                data={DATA[7]}
              />

              <VerticalBarSeries
                cluster="Bitrate: 320 kbps"
                color="#0033FF"
                data={DATA[8]}
              />

            </FlexibleWidthXYPlot>
          </div>

          <div className="legend">
            <DiscreteColorLegend
              orientation="horizontal"
              items={[
                {
                  title: '[0] 5120 kbps',
                  color: '#FF0000'
                },
                {
                  title: '[1] 3850 kbps',
                  color: '#FF0000'
                },
                {
                  title: '[2] 2560 kbps',
                  color: '#FF6600'
                },
                {
                  title: '[3] 2240 kbps',
                  color: '#FF9900'
                },
                {
                  title: '[4] 1920 kbps',
                  color: '#FFFF00'
                },
                {
                  title: '[5] 1600 kbps',
                  color: '#66FF00'
                },
                {
                  title: '[6] 1280 kbps',
                  color: '#00FFCC'
                },
                {
                  title: '[7] 640 kbps',
                  color: '#0099FF'
                },
                {
                  title: '[8] 320 kbps',
                  color: '#0033FF'
                }
              ]}
            />
          </div>

        </React.Fragment>
    );
  }
}